@let t = text();

<div class="transits-panel" [class.transits-panel--compact]="effectiveCompact()">
  <!-- Toolbar: titel (verticale weergave) + de weergave-toggle, host-onafhankelijk
       zichtbaar in dialog, dock en pagina. -->
  <div class="transits-panel__toolbar">
    @if (viewMode() === 'vertical') {
      <h3 class="transits-panel__title">{{ t.title }}</h3>
    }
    <e-segmented-toggle
      class="transits-panel__view-toggle"
      testId="transits-view"
      [groupLabel]="t.viewModeLabel"
      [options]="viewModeOptions()"
      [value]="viewMode()"
      (valueChange)="setViewMode($event)"
    ></e-segmented-toggle>
  </div>

  @if (savedMomentId(); as momentId) {
    <div class="transits-panel__banner" role="status" data-test-id="transits-moment-saved">
      <i class="fas fa-calendar-check" aria-hidden="true"></i>
      <span class="transits-panel__banner-text">{{ t.momentSaved }}</span>
      <button type="button" class="transits-panel__banner-action" (click)="openSavedMoment()"
              data-test-id="transits-moment-open">
        {{ t.openMoment }}
      </button>
      <button type="button" class="transits-panel__banner-close" [attr.aria-label]="t.dismiss" [title]="t.dismiss"
              (click)="dismissSavedMoment()">
        <i class="fas fa-xmark" aria-hidden="true"></i>
      </button>
    </div>
  }

  @switch (viewMode()) {
    @case ('vertical') {
      <hd-transits-vertical
        class="transits-panel__vertical"
        [showChiron]="effectiveShowChiron()"
        [compact]="effectiveCompact()"
        [phone]="isSheet"
        [gateShiftBadge]="!dockedInPanel()"
        (momentAddRequested)="openMomentAdd($event)"
        (justNowRequested)="openJustNow()"
        (raveNewYearRequested)="openRaveNewYear($event)"
      />
    }
    @default {
      <hd-transit-now-next-panel
        class="transits-panel__now-next"
        [showChiron]="effectiveShowChiron()"
      ></hd-transit-now-next-panel>
      <hd-ephemeris-lanes
        class="transits-panel__lanes"
        [showChiron]="effectiveShowChiron()"
        (momentAddRequested)="openMomentAdd($event)"
      ></hd-ephemeris-lanes>
    }
  }
</div>

<!-- Moment toevoegen vanuit de transits: chartkeuze (eigen chart voorgeselecteerd),
     tijdstip voorgevuld, categorie daily. -->
<hd-moment-link-dialog
  [(openWithSourcePicker)]="momentPickerOpen"
  [prefillDateUtc]="momentPrefillUtc()"
  [prefillWithTime]="momentPrefillWithTime()"
  [initialMode]="momentInitialMode()"
  defaultCategory="daily"
  (chartCreated)="onMomentCreated($event)"
  (ichingRequested)="onIChingRequested($event)"
></hd-moment-link-dialog>

<!-- I Tjing-raadpleging voor de gekozen chart op het gekozen tijdstip (scroll-plusjes). -->
<hd-iching-moment-dialog [(target)]="ichingDialogTarget"></hd-iching-moment-dialog>
